import { HOTEL_DETAILS_STEPS } from "src/Modules/Hotels/constants";
import useStepFlow from "src/Modules/Hotels/hooks/useStepsFlow";
export default function WizardBody() {
  const { currentStep } = useStepFlow();
  const stepConfig = HOTEL_DETAILS_STEPS.find((hotelStep) => hotelStep.number === currentStep);
  const Component = stepConfig?.Component;
  return Component ?? null;
}
